import { generateReadOneActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readCampaignHistory: generateReadOneActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.CAMPAIGN_HISTORY, 'history')
}
